"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.factorialDependencies = void 0;
var _dependenciesGammaGenerated = require("./dependenciesGamma.generated.js");
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var factorialDependencies = exports.factorialDependencies = {
  gammaDependencies: _dependenciesGammaGenerated.gammaDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createFactorial: _factoriesAny.createFactorial
};